import { Box, Stack } from 'braid-design-system';
import slugify from 'slugify';

import { Nav } from 'src/components/Nav/Nav';
import { PageWrapper } from 'src/components/PageWrapper/PageWrapper';
import { TabbedNav } from 'src/components/TabbedNav/TabbedNav';
import { whatsPossibleLinks } from 'src/routes';

import { SharedCTABlock } from './SharedCTABlock';
import { SharedIconBlock } from './SharedIconBlock';

interface Props {
  page: string;

  children: any;
}

export const SolutionsWrapper = ({ page, children }: Props) => {
  const pageTrackingProps = {
    page: slugify(page),
    eventName: `${slugify(page, { lower: true })}-viewed`,
    siteSection: 'partners',
    subSection: 'whats-possible',
  };

  return (
    <PageWrapper pageTrackingProps={pageTrackingProps} title={page}>
      <Box background="surface" paddingBottom="large">
        <Nav activeTab="whats-possible" />
        <Stack space="xlarge">
          <SharedIconBlock />
          <TabbedNav links={whatsPossibleLinks} active={page} />
          {children}
          <SharedCTABlock />
        </Stack>
      </Box>
    </PageWrapper>
  );
};
